import { FormCheck } from 'components/form/FormCheck';
import { Button } from 'components/Button';
import i18n from 'components/translation/i18n';
import { classNames, React, useEffect, useState } from 'libs/react';
import './CookieConsentBanner.scss';
/**
 * @component CookieConsentBanner
 * @since 1.0.0
 */
export function CookieConsentBanner(props) {
    const { className, privacyPolicyUrl, onChoice } = props;
    const [customizing, setCustomizing] = useState(false);
    const [analyticsChecked, setAnalyticsChecked] = useState(true);
    // Rendered above the translation provider: follow language changes (the
    // user's language loads after the domain)
    const [, setLanguage] = useState(i18n.language);
    useEffect(() => {
        i18n.on('languageChanged', setLanguage);
        return () => i18n.off('languageChanged', setLanguage);
    }, []);
    return (React.createElement("div", { className: classNames('cookie-consent-banner', className), role: "region", "aria-label": t('Cookie preferences') },
        React.createElement("p", { className: "cookie-consent-banner__notice" },
            t('We use cookies to measure audience and improve your experience. You can accept, reject, or customize your choices at any time.'),
            ' ',
            React.createElement("a", { href: privacyPolicyUrl, target: "_blank", rel: "noreferrer" }, t('privacy policy.'))),
        customizing && (React.createElement("div", { className: "cookie-consent-banner__categories" },
            React.createElement("div", { className: "cookie-consent-banner__check" },
                React.createElement(FormCheck, { name: "cookieConsentNecessary", checked: true, disabled: true, label: t('Necessary'), infos: t('Required for the site to function. Cannot be disabled.') })),
            React.createElement("div", { className: "cookie-consent-banner__check" },
                React.createElement(FormCheck, { name: "cookieConsentAnalytics", checked: analyticsChecked, onChange: setAnalyticsChecked, label: t('Analytics & advertising'), infos: t('Helps us measure audience and personalize advertising.') })))),
        React.createElement("div", { className: "cookie-consent-banner__actions" }, customizing ? (React.createElement(Button, { style: "primary", label: t('Save my choices'), onPress: () => onChoice({
                analytics: analyticsChecked,
                ads: analyticsChecked
            }) })) : (React.createElement(React.Fragment, null,
            React.createElement(Button, { style: "outline", label: t('Reject all'), onPress: () => onChoice({ analytics: false, ads: false }) }),
            React.createElement(Button, { style: "outline", label: t('Customize'), onPress: () => setCustomizing(true) }),
            React.createElement(Button, { style: "primary", label: t('Accept all'), onPress: () => onChoice({ analytics: true, ads: true }) }))))));
}
